export default "__VITE_ASSET__zlhRnZFN__"